import React, { useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import ReactPlayer from 'react-player';

import Link from 'next/link';
import Image from 'next/image';
import IMAGE_SIZE, { type ImageSize } from '@/constants/image-size.constants';
import { getImageUrl } from '@/services/media.service';
import { ON_DEMAND_DATE_FORMAT } from '@/constants/article.constants';
import { ContentfulDocument } from '@/components/Contentful/ContentfulDocument';
import Picture from '../Picture';
import { stringHasValue } from '@/utils/data';
type OnDemandProps = {
  content: OnDemand;
  imageSize: ImageSize;
  className?: string;
  canViewRecordings?: boolean;
};

const OnDemandContent = ({
  content,
  imageSize,
  className,
  canViewRecordings
}: OnDemandProps) => {
  const contentId = useRef<string>(content.id);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (content.id !== contentId.current) {
      // viewEventSent = false;
      contentId.current = content.id;
    }
  }, [content.id]);

  useEffect(() => {
    const updateViewCount = async () => {
      if (contentId) {
        await fetch(`/api/on-demand/${contentId.current}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ event: 'viewed' })
        });
      }
    };
    void updateViewCount();
  }, [contentId.current, isClient]);

  const {
    id,
    title,
    featuredImage,
    overview,
    recordings,
    price,
    date,
    relatedEvents,
    primaryTag
  } = content;
  let url;
  // const width = featuredImage?.file?.details?.image?.width ? featuredImage?.file?.details?.image?.width : IMAGE_SIZE.TABLET_IMAGE;
  // const height = featuredImage?.file?.details?.image?.height ? featuredImage?.file?.details?.image?.height : IMAGE_SIZE.TABLET_IMAGE

  if (featuredImage?.file?.url.includes('images.ctfassets.net')) {
    url = getImageUrl(featuredImage.file.url);
    featuredImage.file.url = url?.href ?? '';
  }

  return (
    <>
      <div className='article__info-block'>
        {/* {category.trim() !== '' ? (
          <span className="article__info-block__type">
            <span className='sr-only'>Categor{category.includes(',') ? 'ies' : 'y' }: </span>
            {category}
          </span>
        ) : null} */}
        {primaryTag && (
          <span className='article__info-block__type'>
            <span className='sr-only'>Category</span>
            {primaryTag.name}
          </span>
        )}
        <span className='article__info-block__date'>
          <span className='sr-only'>Date: </span>
          <time dateTime={format(new Date(date), ON_DEMAND_DATE_FORMAT)}>
            {format(new Date(date), ON_DEMAND_DATE_FORMAT)}
          </time>
        </span>
      </div>
      <h1 className='article__name'>{title}</h1>
      {featuredImage && url && stringHasValue(url.href) ? (
        <div className='article__feature-image-container'>
          <Picture src={url.href} width={IMAGE_SIZE.ARTICLE_FEATURE} />
        </div>
      ) : (
        <div
          className='ondemand__media-main'
          style={{
            backgroundImage: 'url("/static/imgs/trending/trending.jpg")'
          }}
        />
      )}
      <div className='overview'>
        {overview ? <ContentfulDocument document={overview} /> : null}
      </div>
      {canViewRecordings && recordings && recordings.length > 0 ? (
        <div className='recordings'>
          <div>
            {recordings.map((recording) => (
              <div key={recording.id} className='recording'>
                <div className='article__info-block'>
                  <span>{recording.recordingType}</span>
                </div>
                <h2>{recording.title}</h2>
                <div className='section'>
                  {documentToReactComponents(recording.description!, {
                    preserveWhitespace: true
                  })}
                </div>
                <div className='section'>
                  {recording.embedLink ? (
                    <div className='video-wrapper'>
                      {isClient ? (
                        <ReactPlayer
                          url={recording.embedLink}
                          controls={true}
                          className='react-player'
                          width='100%'
                          height={'100%'}
                        />
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className='section'>
                  {recording.media ? (
                    <div className='video-wrapper'>
                      <ReactPlayer
                        url={recording.media}
                        controls={true}
                        className='react-player'
                        width='100%'
                        height={'100%'}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default OnDemandContent;
